import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { upperCase } from 'lodash';
import LinkModal from '@/components/LinkModal.vue';
import VueMarkdown from 'vue-markdown';
const powersModule = namespace('powers');
let MonsterPower = class MonsterPower extends Vue {
    created() {
        this.fetchPowers();
    }
    get powerData() {
        return this.powerList && this.powerList.map((powerString, index) => {
            const propertyName = upperCase(powerString.split(' ')[0]);
            const text = (index > 0 ? ', ' : ' ') + powerString;
            const powerInfo = this.powers.find(({ name }) => upperCase(name) === propertyName);
            return { ...powerInfo, text };
        }).filter(({ description }) => description);
    }
};
__decorate([
    Prop(Array)
], MonsterPower.prototype, "powerList", void 0);
__decorate([
    powersModule.State
], MonsterPower.prototype, "powers", void 0);
__decorate([
    powersModule.Action
], MonsterPower.prototype, "fetchPowers", void 0);
MonsterPower = __decorate([
    Component({
        components: {
            LinkModal,
            VueMarkdown
        }
    })
], MonsterPower);
export default MonsterPower;
